import React, { useState, useEffect } from 'react';
import {
	Grid,
	Typography,
	TextField,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	MenuItem,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { Card, Alert } from "reactstrap";
import Layout from "../../components/Wrappers/Layout";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
// import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { getVoucherWireManager } from '../../redux/actions/getVoucherWireManagerAction';
import { makeStyles, useTheme } from "@mui/styles";
import moment from "moment";
import SOLogout from "../../components/Logout/SOLogout";
import { updateOrAddVoucherWire } from '../../redux/actions/updateOrAddVoucherWireAction';
import { getAccountIdList } from '../../redux/actions/getAccountIdListAction';
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import { Tooltip } from 'antd';
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});
// const useStyles = makeStyles((theme) => ({
// 	table: {
// 		minWidth: 650
// 	}
// }));

function VoucherWireManager() {

	const [ids, setids] = useState('');
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);

	const [getVoucherWireManagerStatus, setGetVoucherWireManagerStatus] = useState(false);
	const [getVoucherWireManagerArray, setgetVoucherWireManagerArray] = useState("");

	const [viewOpen, setviewOpen] = useState(false);
	// view dialogue one values: 
	const [accountID, setaccountID] = useState('');
	const [bank_end_date, setbank_end_date] = useState('');
	const [bankStartDate, setbankStartDate] = useState('');
	const [wireID, setwireID] = useState('');
	const [grossAmount, setgrossAmount] = useState('');
	const [payoutCronExecuted, setpayoutCronExecuted] = useState('');
	const [settlementCronExecuted, setsettlementCronExecuted] = useState('');
	const [netFinalAmount, setnetFinalAmount] = useState('');
	const [processingAmount, setprocessingAmount] = useState('');
	const [settledDate, setsettledDate] = useState('');
	const [unpaidAmount, setunpaidAmount] = useState('');
	const [settledTime, setsettledTime] = useState('')
	const [startTime, setstartTime] = useState('');
	const [endTime, setendTime] = useState('')
	const [descriptionData, setdescriptionData] = useState('')
	const [popupHandle, setpopupHandle] = useState(false)

	const [editOpen, seteditOpen] = useState(false)
	const [editData, seteditData] = useState('')

	// add voucher wire
	const [addVoucherDialog, setaddVoucherDialog] = useState(false);
	const [addSettlementDate, setaddSettlementDate] = useState('')
	const [addSettlementTime, setaddSettlementTime] = useState('');
	const [addAccountID, setaddAccountID] = useState('');
	const [addStartDate, setaddStartDate] = useState('');
	const [addStartTime, setaddStartTime] = useState('');
	const [addEndDate, setaddEndDate] = useState('');
	const [addEndTime, setaddEndTime] = useState('');
	const [addProcessingAmount, setaddProcessingAmount] = useState('');
	const [addGrossAmount, setaddGrossAmount] = useState('');
	const [addNetFinalAmount, setaddNetFinalAmount] = useState('');
	const [addUnpaidAmount, setaddUnpaidAmount] = useState('');

	const classes = useStyles();
	const theme = useTheme();
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	// const handleChangeRowsPerPage = (event) => {
	// 	setRowsPerPage(parseInt(event.target.value, 10));
	// 	setPage(0);
	// };

	const handleChangeRowsPerPage = (event) => {
		const newRowsPerPage = parseInt(event.target.value, 10);
		const currentFirstRowIndex = page * rowsPerPage;
		const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);

		setRowsPerPage(newRowsPerPage);
		setPage(newPage);
	};

	const handleChange = e => {
		const name = e.target.name;
		const value = e.target.value;
		setids(values => ({ ...values, [name]: value }))
	}

	const dispatch = useDispatch();

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	var authToken = regenerateTokenRes.data.AuthToken;

	var voucherres = useSelector(({ getvoucherwiremanager }) => getvoucherwiremanager);

	var updateOrDeleteVoucherWireRes = useSelector(({ updateoraddvoucherwire }) => updateoraddvoucherwire);

	const searchfunction = s => {
		setGetVoucherWireManagerStatus(true);
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId,
				accountId: ids.accountId,
				wireId: ids.bankWireId
			}
		}
		dispatch(getVoucherWireManager(req, authToken))
	}

	const getVoucherWireManagerStatusFunc = () => {
		if (getVoucherWireManagerStatus) {
			if (voucherres.data.status == 'success') {
				setgetVoucherWireManagerArray([].concat(voucherres.data.voucherList))
			}
			if (voucherres.data.status == 'failed') {
				setgetVoucherWireManagerArray(voucherres.data);
				if (
					voucherres.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					voucherres.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			searchfunction();
		}
	}, [regenerateTokenRes.data.status]);
	// useEffect(() => {
	// 	if (voucherres.data.status == "success") {
	// 		setPage(0);
	// 	}
	// }, [voucherres.data.status]);

	useEffect(() => {
		if (voucherres.data.status) {
			getVoucherWireManagerStatusFunc();
			setPage(0);
		}
	}, [voucherres.data.status])

	const handleClose = () => {
		setviewOpen(false);
		seteditOpen(false);
		setaddVoucherDialog(false);
		searchfunction();
	};

	const viewDialogOpen = (
		accountId,
		bank_end_date,
		bank_start_date,
		bankwiremanagerId,
		grossAmount,
		isPayoutCronExcuted,
		isSettlementCronExceuted,
		netfinal_amount,
		processing_amount,
		settleddate,
		unpaid_amount,
	) => {
		setaccountID(accountId);
		setbank_end_date(bank_end_date);
		setbankStartDate(bank_start_date);
		setwireID(bankwiremanagerId);
		setgrossAmount(grossAmount);
		setpayoutCronExecuted(isPayoutCronExcuted);
		setsettlementCronExecuted(isSettlementCronExceuted);
		setnetFinalAmount(netfinal_amount);
		setprocessingAmount(processing_amount);
		setsettledDate(settleddate);
		setunpaidAmount(unpaid_amount);
		setviewOpen(true)
	}

	const getDate = dates => {
		const d = new Date(dates);
		let dt = (d.getDate().toString().length) != 2 ? ('0' + d.getDate()) : (d.getDate());
		let dm = ((d.getMonth() + 1).toString().length) != 2 ? ('0' + (d.getMonth() + 1)) : (d.getMonth() + 1);
		let dd = d.getFullYear() + '-' + dm + '-' + dt;
		// console.log('date format: ', dd);
		return dd;
	}

	const getTime = times => {
		const t = new Date(times);
		return t.toLocaleTimeString('en-gb');
	}

	const editDialogOpen = (
		accountId,
		bank_end_date,
		bank_start_date,
		bankwiremanagerId,
		grossAmount,
		isPayoutCronExcuted,
		isSettlementCronExceuted,
		netfinal_amount,
		processing_amount,
		settleddate,
		unpaid_amount,
	) => {
		setaccountID(accountId);
		setbank_end_date(getDate(bank_end_date));
		setendTime(getTime(bank_end_date));
		setbankStartDate(getDate(bank_start_date));
		setstartTime(getTime(bank_start_date));
		setwireID(bankwiremanagerId);
		setgrossAmount(grossAmount);
		setpayoutCronExecuted(isPayoutCronExcuted);
		setsettlementCronExecuted(isSettlementCronExceuted);
		setnetFinalAmount(netfinal_amount);
		setprocessingAmount(processing_amount);
		setsettledDate(getDate(settleddate));
		setsettledTime(getTime(settleddate))
		setunpaidAmount(unpaid_amount);
		seteditOpen(true);
	}

	const handleEditDialog = ({ target: { name, value } }) => {
		if (name === 'wireID') {
			const vatRates = parseFloat(value)
			if (vatRates >= 0 || value === '') {
				setwireID(value)
			}
		
		}
		if (name === 'settledDate') {
			setsettledDate(value)
		}
		if (name === 'accountID') {
			setaccountID(value)
		}
		if (name === 'startDate') {
			setbankStartDate(value)
		}
		if (name === 'endDate') {
			setbank_end_date(value)
		}
		if (name === 'processingAmount') {
			setprocessingAmount(value)
		}
		if (name === 'grossAmount') {
			setgrossAmount(value)
		}
		if (name === 'netFinalAmount') {
			setnetFinalAmount(value)
		}
		if (name === 'unpaidAmount') {
			setunpaidAmount(value)
		}
		if (name === 'isSettlementCronExecuted') {
			setsettlementCronExecuted(value)
		}
		if (name === 'isPayoutCronExecuted') {
			setpayoutCronExecuted(value)
		}
		if (name === 'settledTime') {
			setsettledTime(value)
		}
		if (name === 'startTime') {
			setstartTime(value)
		}
		if (name === 'endTime') {
			setendTime(value)
		}
	}

	const submitDialog = e => {
		e.preventDefault();
		let endtimem = moment(endTime, 'HH:mm')
		let startimem = moment(startTime, 'HH:mm')
		let settledtimem = moment(settledTime, 'HH:mm');
		const req = {
			actionCustomerMasterRequestVO: {
				action: 'update',
				walletOwnerId: regenerateTokenRes.data.partnerId,
				bankWireId: wireID,
				settleDate: moment(settledDate).format('DD/MM/YYYY'),
				settleDateTimestamp: settledtimem.format('HH:mm:ss'),
				accountId: accountID,
				startDate: moment(bankStartDate).format('DD/MM/YYYY'),
				startTime: startimem.format('HH:mm:ss'),
				endDate: moment(bank_end_date).format('DD/MM/YYYY'),
				endTime: endtimem.format('HH:mm:ss'),
				processingAmount: processingAmount,
				grossAmount: grossAmount,
				netFinalAmount: netFinalAmount,
				unpaidAmount: unpaidAmount,
				isSettleCronExc: settlementCronExecuted === "Yes" ? 'Y' : '' || settlementCronExecuted === 'No' ? 'N' : '',
				isPayoutCronExc: payoutCronExecuted === 'Yes' ? 'Y' : '' || payoutCronExecuted === 'No' ? 'N' : '',
				memberId: ""
			}
		}
		// console.log('Update Request: ', req);
		dispatch(updateOrAddVoucherWire(req, authToken));
		updateOrDeleteVoucherWireStatusFunc();
	}

	const updateOrDeleteVoucherWireStatusFunc = () => {
		// console.log('Res Obj: ', updateOrDeleteVoucherWireRes );
		if (updateOrDeleteVoucherWireRes) {
			if (updateOrDeleteVoucherWireRes.data.status == 'success') {
				setdescriptionData(updateOrDeleteVoucherWireRes.data);
				setpopupHandle(true);
			}
		}
		if (updateOrDeleteVoucherWireRes) {
			if (updateOrDeleteVoucherWireRes.data.status == 'failed') {
				setdescriptionData(updateOrDeleteVoucherWireRes.data);
				setpopupHandle(true);
				if (
					updateOrDeleteVoucherWireRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateOrDeleteVoucherWireRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
		// if( updateOrDeleteVoucherWireRes.network ) {
		// 	setdescriptionData(updateOrDeleteVoucherWireRes.data.description);
		// 	setpopupHandle(true);
		// }
	}

	const closePopup = () => {
		setpopupHandle(false);
		seteditOpen(false);
		setaddVoucherDialog(false);
		setdescriptionData('')
		searchfunction();
	}

	// useEffect( () => {
	// 	if ( updateOrDeleteVoucherWireRes.data.status ==='success' ) {
	// 		updateOrDeleteVoucherWireStatusFunc();
	// 	}
	// }, [updateOrDeleteVoucherWireRes.data.status] )

	const handleAddDialog = ({ target: { name, value } }) => {
		if (name === 'addAccountID') {
			setaddAccountID(value);
		}
		if (name === 'addStartDate') {
			setaddStartDate(value);
		}
		if (name === 'addStartTime') {
			setaddStartTime(value);
		}
		if (name === 'addEndDate') {
			setaddEndDate(value);
		}
		if (name === 'addEndTime') {
			setaddEndTime(value);
		}
		if (name === 'addProcessingAmount') {
			setaddProcessingAmount(value);
		}
		if (name === 'addGrossAmount') {
			setaddGrossAmount(value);
		}
		if (name === 'addNetFinalAmount') {
			setaddNetFinalAmount(value);
		}
		if (name === 'addUnpaidAmount') {
			setaddUnpaidAmount(value);
		}
		if (name === 'addSettlementDate') {
			setaddSettlementDate(value);
		}
		if (name === 'addSettlementTime') {
			setaddSettlementTime(value);
		}
	}

	const accountlist = useSelector(({ getaccoutidlist }) => getaccoutidlist);

	const openAddVoucherDialog = () => {
		const ds = new Date();
		const todaysDate = getDate(ds);
		const todaysTime = getTime(ds);
		setaddStartDate(todaysDate);
		setaddStartTime(todaysTime);
		setaddEndDate(todaysDate);
		setaddEndTime(todaysTime);
		setaddSettlementDate(todaysDate);
		setaddSettlementTime(todaysTime);
		setaddVoucherDialog(true);
		const reqIdList = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId
			}
		}
		dispatch(getAccountIdList(reqIdList, authToken));
	}

	const addVoucherSubmit = e => {
		e.preventDefault();

		// startDate: moment(bankStartDate).format('DD/MM/YYYY'),
		// startTime: startimem.format('HH:mm:ss'),
		let starttime = moment(addStartTime, 'HH:mm');
		let endtime = moment(addEndTime, 'HH:mm');
		let settledtime = moment(addSettlementTime, 'HH:mm');
		const req = {
			actionCustomerMasterRequestVO: {
				action: 'add',
				walletOwnerId: regenerateTokenRes.data.partnerId,
				settleDate: moment(addSettlementDate).format('DD/MM/YYYY'),
				settleDateTimestamp: settledtime.format('HH:mm:ss'),
				accountId: addAccountID,
				startDate: moment(addStartDate).format('DD/MM/YYYY'),
				startTime: starttime.format('HH:mm:ss'),
				endDate: moment(addEndDate).format('DD/MM/YYYY'),
				endTime: endtime.format('HH:mm:ss'),
				processingAmount: addProcessingAmount,
				grossAmount: addGrossAmount,
				netFinalAmount: addNetFinalAmount,
				unpaidAmount: addUnpaidAmount,
				memberId: ''
			}
		}
		// console.log('addVoucherSubmit Request: ', req);
		dispatch(updateOrAddVoucherWire(req, authToken))
		updateOrDeleteVoucherWireStatusFunc();
	}

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{ padding: "25px", gap: "20px", justifyContent: "right" }}
					>
						{/* <Grid item md={7} sm={12} lg={5}></Grid> */}
						<Grid item md={3} sm={12} xs={12} lg={3}>
							{/* <NavLink to="/index/addNewFeeWallet"> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={openAddVoucherDialog}
							>
								Add New Voucher Wire
							</CustomButton>
							{/* </NavLink> */}
						</Grid>
					</Grid>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Wire ID"
								type="text"
								fullWidth
								variant="standard"
								name="bankWireId"
								value={ids.bankWireId || ""}
								onChange={handleChange}
								sx={{
									"& .MuiInput-underline:before": {
									  borderBottomColor: "gray", // White color for the underline before focus
									},
									"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
									  borderBottomColor: "gray", // White color on hover
									},
									"& .MuiInput-underline:after": {
									  borderBottomColor: "gray", // White color after focus
									},
								  }}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								margin="dense"
								id="name"
								label="Account ID"
								type="text"
								fullWidth
								variant="standard"
								name="accountId"
								value={ids.accountId || ""}
								onChange={handleChange}
								sx={{
									"& .MuiInput-underline:before": {
									  borderBottomColor: "gray", // White color for the underline before focus
									},
									"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
									  borderBottomColor: "gray", // White color on hover
									},
									"& .MuiInput-underline:after": {
									  borderBottomColor: "gray", // White color after focus
									},
								  }}
							/>
						</Grid>
						<Grid
							item
							xs={12}
							sm={12}
							md={4}
							lg={4}
							style={{
								padding: "10px",
								marginTop: "0.5rem",
								marginBottom: "15px"
							}}
						>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={searchfunction}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>
				{
					getVoucherWireManagerArray.length == undefined || !getVoucherWireManagerStatus ? (
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Report Table
									</Typography>
								</Grid>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Alert
										className="my-3 tableHeaderColor"
										variant="secondary"
										style={{ color: "white" }}
									>
										No Records Found!
									</Alert>
								</Grid>
							</Grid>
						</Card>
					) : (
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Report Table
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="my-3">
									<Table className={classes.table}>
										<TableHead>
											<TableRow className="tableHeaderColor">
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Sr No.{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Wire ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Settled Date
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Account ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Start Date
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													End Date
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Action
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{getVoucherWireManagerArray &&
												[]
													.concat(getVoucherWireManagerArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((r, index) => (
														<TableRow key={r.index}>
															<TableCell align="center">
																{index + 1}
															</TableCell>
															<TableCell align="center">
																{r.bankwiremanagerId}
															</TableCell>
															<TableCell align="center">
																{r.settleddate}
															</TableCell>
															<TableCell align="center">
																{r.accountId}
															</TableCell>
															<TableCell align="center">
																{r.bank_start_date}
															</TableCell>
															<TableCell align="center">
																{r.bank_end_date}
															</TableCell>
															<TableCell align="center">
																{/* {console.log("Viewssss",viewDialogOpen)} */}
																{/* <CustomButton
																	style={{
																		padding: "8px",
																		margin: '0 8px'
																	}}
																	onClick={() => 
																		viewDialogOpen(
																		r.accountId,
																		r.bank_end_date,
																		r.bank_start_date,
																		r.bankwiremanagerId,
																		r.grossAmount,
																		r.isPayoutCronExcuted,
																		r.isSettlementCronExceuted,
																		r.netfinal_amount,
																		r.processing_amount,
																		r.settleddate,
																		r.unpaid_amount,
																	)}
																>
																	{
																		<VisibilityIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton> */}
																<Tooltip title="View">
																	<CustomButton
																		style={{
																			padding: "8px",
																			margin: '0 8px'
																		}}
																		onClick={() => {
																			console.log({
																				accountId: r.accountId,
																				bank_end_date: r.bank_end_date,
																				bank_start_date: r.bank_start_date,
																				bankwiremanagerId: r.bankwiremanagerId,
																				grossAmount: r.grossAmount,
																				isPayoutCronExcuted: r.isPayoutCronExcuted,
																				isSettlementCronExceuted: r.isSettlementCronExceuted,
																				netfinal_amount: r.netfinal_amount,
																				processing_amount: r.processing_amount,
																				settleddate: r.settleddate,
																				unpaid_amount: r.unpaid_amount
																			});
																			viewDialogOpen(
																				r.accountId,
																				r.bank_end_date,
																				r.bank_start_date,
																				r.bankwiremanagerId,
																				r.grossAmount,
																				r.isPayoutCronExcuted,
																				r.isSettlementCronExceuted,
																				r.netfinal_amount,
																				r.processing_amount,
																				r.settleddate,
																				r.unpaid_amount,
																			)
																		}}
																	>
																		<VisibilityIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	</CustomButton>
																</Tooltip>
																<Tooltip title="Edit">

																	<CustomButton
																		style={{
																			padding: "8px",
																			margin: '0 8px'
																		}}
																		onClick={() => {
																			editDialogOpen(
																				r.accountId,
																				r.bank_end_date,
																				r.bank_start_date,
																				r.bankwiremanagerId,
																				r.grossAmount,
																				(r.isPayoutCronExcuted === 'Y') ? 'Yes' : '' || (r.isPayoutCronExcuted === 'N') ? 'No' : '',
																				(r.isSettlementCronExceuted === 'Y') ? 'Yes' : '' || (r.isSettlementCronExceuted === 'N') ? 'No' : '',
																				r.netfinal_amount,
																				r.processing_amount,
																				r.settleddate,
																				r.unpaid_amount,
																			);
																		}}
																	>
																		{
																			<EditIcon
																				style={{
																					color: "#fff",
																					fontSize: "20px",
																				}}
																			/>
																		}
																	</CustomButton>
																</Tooltip>

															</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={getVoucherWireManagerArray.length}
										rowsPerPage={rowsPerPage}
										page={page}
										onPageChange={handleChangePage}
										onRowsPerPageChange={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					)
				}
				<div>
					<Dialog open={viewOpen} onClose={handleClose}>
						<DialogTitle
							style={{ color: "#484848 !important" }}
							className="themeText"
						>
							Voucher Wire Manager
						</DialogTitle>

						{/* <DialogTitle id="alert-dialog-title">
							{"Use Google's location service?"}
						</DialogTitle> */}
						<DialogContent>

							<TextField
								style={{ marginTop: "10px" }}

								name="wireID"
								value={wireID || ""}
								onChange={handleChange}
								disabled
								type="text"
                                label="Voucher Wire ID"
								margin="dense"

								fullWidth
								variant="standard"
							/>
							<div style={{ display: 'flex' }}>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									variant="standard"

									type="date"
									label="Settled Date (MM/DD/YYYY)"
									fullWidth
									name="settledDate"
									value={getDate(settledDate) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									variant="standard"

									type="text"
									label="Settled Time"
									fullWidth
									name="settledTime"
									value={getTime(settledDate) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
							</div>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								variant="standard"

								type="text"
								label="Account ID"
								fullWidth
								name="accountID"
								value={accountID || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<div style={{ display: 'flex' }}>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									variant="standard"

									type="date"
									label="Start Date (MM/DD/YYYY)"
									fullWidth
									name="startDate"
									value={getDate(bankStartDate) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									variant="standard"

									type="text"
									label="Start Time"
									fullWidth
									name="startTime"
									value={getTime(bankStartDate) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
							</div>
							<div style={{ display: 'flex' }}>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									variant='standard'

									type="date"
									label="End Date (MM/DD/YYYY)"
									fullWidth
									name="endDate"
									value={getDate(bank_end_date) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									variant='standard'
									type="text"
									label="End Time"
									fullWidth
									name="endTime"
									value={getTime(bank_end_date) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
							</div>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								variant="standard"

								type="text"
								label="Processing Amount"
								fullWidth
								name="processingAmount"
								value={processingAmount || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								variant="standard"

								type="text"
								label="Gross Amount"
								fullWidth
								name="grossAmount"
								value={grossAmount || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								variant="standard"

								type="text"
								label="Net Final Amount"
								fullWidth
								name="netFinalAmount"
								value={netFinalAmount || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								variant="standard"

								type="text"
								label="Unpaid Amount"
								fullWidth
								name="unpaidAmount"
								value={unpaidAmount || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								variant="standard"

								type="text"
								label="Is SettlementCronExecuted"
								fullWidth
								name="isSettlementCronExecuted"
								value={(settlementCronExecuted === 'Y') ? 'Yes' : 'No' || ""}
								onChange={handleChange}
								disabled
							>
								<MenuItem value='Yes'>Yes</MenuItem>
								<MenuItem value='No'>No</MenuItem>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								variant="standard"

								type="text"
								label="Is PayoutCronExecuted"
								fullWidth
								name="isPayoutCronExecuted"
								value={(payoutCronExecuted === 'Y') ? 'Yes' : 'No' || ""}
								onChange={handleChange}
								disabled
							>
								<MenuItem value='Yes'>Yes</MenuItem>
								<MenuItem value='No'>No</MenuItem>
							</TextField>

							{/* <div style={{ display: 'flex' }}>
								<TextField
									style={{ marginTop: "10px" }}
					size='small'
								
									type="date"
									label="Settled Date (MM/DD/YYYY)"
									fullWidth
									name="settledDate"
									value={getDate(settledDate) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
								<TextField
									style={{ marginTop: "10px" }}
								size='small'
									type="text"
									label="Settled Time"
									fullWidth
									name="settledTime"
									value={getTime(settledDate) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
							</div> */}
						</DialogContent>
						<DialogActions>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>

					{/* <Dialog open={viewOpen} onClose={handleClose}>
						<DialogTitle
							style={{ color: "#484848 !important" }}
							className="themeText"
						>
							Voucher Wire Manager
						</DialogTitle>
						<DialogContent>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="#484848"
								type="text"
								label="Voucher Wire ID"
								fullWidth
								name="wireID"
								value={wireID || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<div style={{ display: 'flex' }}>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									color="#484848"
									type="date"
									label="Settled Date (MM/DD/YYYY)"
									fullWidth
									name="settledDate"
									value={getDate(settledDate) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									color="#484848"
									type="text"
									label="Settled Time"
									fullWidth
									name="settledTime"
									value={getTime(settledDate) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
							</div>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="#484848"
								type="text"
								label="Account ID"
								fullWidth
								name="accountID"
								value={accountID || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<div style={{ display: 'flex' }}>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									color="#484848"
									type="date"
									label="Start Date (MM/DD/YYYY)"
									fullWidth
									name="startDate"
									value={getDate(bankStartDate) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									color="#484848"
									type="text"
									label="Start Time"
									fullWidth
									name="startTime"
									value={getTime(bankStartDate) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
							</div>
				
							<div style={{ display: 'flex' }}>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									color="#484848"
									type="date"
									label="End Date (MM/DD/YYYY)"
									fullWidth
									name="endDate"
									value={getDate(bank_end_date) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									color="#484848"
									type="text"
									label="End Time"
									fullWidth
									name="endTime"
									value={getTime(bank_end_date) || ""}
									onChange={handleChange}
									disabled
								>
								</TextField>
							</div>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="#484848"
								type="text"
								label="Processing Amount"
								fullWidth
								name="processingAmount"
								value={processingAmount || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="#484848"
								type="text"
								label="Gross Amount"
								fullWidth
								name="grossAmount"
								value={grossAmount || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="#484848"
								type="text"
								label="Net Final Amount"
								fullWidth
								name="netFinalAmount"
								value={netFinalAmount || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="#484848"
								type="text"
								label="Unpaid Amount"
								fullWidth
								name="unpaidAmount"
								value={unpaidAmount || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="#484848"
								type="text"
								label="Is SettlementCronExecuted"
								fullWidth
								name="isSettlementCronExecuted"
								value={(settlementCronExecuted === 'Y') ? 'Yes' : 'No' || ""}
								onChange={handleChange}
								disabled
							>
								<MenuItem value='Yes'>Yes</MenuItem>
								<MenuItem value='No'>No</MenuItem>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="#484848"
								type="text"
								label="Is PayoutCronExecuted"
								fullWidth
								name="isPayoutCronExecuted"
								value={(payoutCronExecuted === 'Y') ? 'Yes' : 'No' || ""}
								onChange={handleChange}
								disabled
							>
								<MenuItem value='Yes'>Yes</MenuItem>
								<MenuItem value='No'>No</MenuItem>
							</TextField>
						</DialogContent>
						<DialogActions>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog> */}
					<Dialog open={editOpen} onClose={handleClose}>
						<DialogTitle
							style={{ color: "#484848 !important" }}
							className="themeText"
						>
							Update Voucher Wire
						</DialogTitle>
						<DialogContent>
							<TextField

								style={{ marginTop: "10px" }}
								required
								// size="small"
								// color="#484848"
								margin="dense"
								type="number"
								label="Voucher Wire ID"
								fullWidth
								name="wireID"
								value={wireID || ""}
								onChange={handleEditDialog}

							>
							</TextField>



							<div style={{ display: 'flex' }}>
								<TextField
									style={{ marginTop: "10px" }}
									required
									size="small"
									variant="standard"
									// color="#484848"
									type="date"
									label="Settled Date (MM/DD/YYYY)"
									fullWidth
									name="settledDate"
									value={settledDate || ""}
									onChange={handleEditDialog}
								>
								</TextField>


								<TextField
									style={{ marginTop: "10px" }}
									required
									size="small"
									variant="standard"
									// color="#484848"
									type="text"
									label="Settled Time"
									fullWidth
									name="settledTime"
									value={settledTime || ""}
									onChange={handleEditDialog}
								>
								</TextField>
							</div>
							<TextField
								style={{ marginTop: "10px" }}
								required
								size="small"
								variant="standard"
								type="number"
								label="Account ID"
								fullWidth
								name="accountID"
								value={accountID || ""}
								onChange={handleEditDialog}
							>
							</TextField>
							<div style={{ display: 'flex' }}>
								<TextField
									style={{ marginTop: "10px" }}
									required
									size="small"
									variant="standard"
									type="date"
									label="Start Date (MM/DD/YYYY)"
									fullWidth
									name="startDate"
									value={bankStartDate || ""}
									onChange={handleEditDialog}
								>
								</TextField>
								<TextField
									style={{ marginTop: "10px" }}
									required
									variant="standard"
									size="small"
									type="text"
									label="Start Time"
									fullWidth
									name="startTime"
									value={startTime || ""}
									onChange={handleEditDialog}
								>
								</TextField>
							</div>
							<div style={{ display: 'flex' }}>
								<TextField
									style={{ marginTop: "10px" }}
									required
									size="small"
									variant="standard"
									type="date"
									label="End Date (MM/DD/YYYY)"
									fullWidth
									name="endDate"
									value={bank_end_date || ""}
									onChange={handleEditDialog}
								>
								</TextField>
								<TextField
									style={{ marginTop: "10px" }}
									required
									size="small"
									variant="standard"
									type="text"
									label="End Time"
									fullWidth
									name="endTime"
									value={endTime || ""}
									onChange={handleEditDialog}
								>
								</TextField>
							</div>
							<TextField
								style={{ marginTop: "10px" }}
								required
								variant="standard"
								size="small"
								type="text"
								label="Processing Amount"
								fullWidth
								name="processingAmount"
								value={processingAmount || ""}
								onChange={handleEditDialog}
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								required
								size="small"
								variant="standard"
								type="text"
								label="Gross Amount"
								fullWidth
								name="grossAmount"
								value={grossAmount || ""}
								onChange={handleEditDialog}
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								required
								size="small"
								variant="standard"
								type="text"
								label="Net Final Amount"
								fullWidth
								name="netFinalAmount"
								value={netFinalAmount || ""}
								onChange={handleEditDialog}
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								required
								size="small"
								variant="standard"
								type="text"
								label="Unpaid Amount"
								fullWidth
								name="unpaidAmount"
								value={unpaidAmount || ""}
								onChange={handleEditDialog}
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								required
								select
								variant="standard"
								size="small"
								// color="#484848"
								type="text"
								label="Is SettlementCronExecuted"
								fullWidth
								name="isSettlementCronExecuted"
								// value={(settlementCronExecuted === 'Y' ) ? 'Yes' : 'No' || ""}
								defaultValue={settlementCronExecuted || ''}
								onChange={handleEditDialog}
							>
								<MenuItem value='Yes'>Yes</MenuItem>
								<MenuItem value='No'>No</MenuItem>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								required
								variant="standard"
								select
								size="small"
								// color="#484848"
								type="text"
								label="Is PayoutCronExecuted"
								fullWidth
								name="isPayoutCronExecuted"
								// value={(payoutCronExecuted === 'Y' ) ? 'Yes' : 'No' || ""}
								defaultValue={payoutCronExecuted || ''}
								onChange={handleEditDialog}
							>
								<MenuItem value='Yes'>Yes</MenuItem>
								<MenuItem value='No'>No</MenuItem>
							</TextField>
						</DialogContent>
						<DialogActions>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={submitDialog}
							>
								Submit
							</CustomButton>
						</DialogActions>
					</Dialog>
					<Dialog open={addVoucherDialog} onClose={handleClose}>
						<DialogTitle
							style={{ color: "#484848 !important" }}
							className="themeText"
						>
							Add Voucher Wire
						</DialogTitle>
						<DialogContent>
							<TextField
								select
								style={{ marginTop: "10px" }}
								size="small"
								type="text"
								required
								label="Account ID"
								fullWidth
								name="addAccountID"
								value={addAccountID || ""}
								onChange={handleAddDialog}
							>
								<MenuItem value="Select Account ID" selected="Select Account ID">
									Select Account ID
								</MenuItem>
								{
									accountlist.success && [].concat(accountlist.data.checkedIdList).map(
										x => <MenuItem value={x.accountId}>
											{x.accountId + '-' + x.memberId + '-' + x.paymodeId + '-' + x.CardType + '-' + x.currency}
										</MenuItem>)
								}
							</TextField>
							<div style={{ display: 'flex' }}>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									type="date"
									label="Settled Date (MM/DD/YYYY)"
									fullWidth
									variant='standard'
									name="addSettlementDate"
									value={addSettlementDate || ""}
									onChange={handleAddDialog}
								>
								</TextField>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									type="text"
									label="Settled Time"
									variant='standard'
									fullWidth
									name="addSettlementTime"
									value={addSettlementTime || ""}
									onChange={handleAddDialog}
								>
								</TextField>
							</div>
							<div style={{ display: 'flex' }}>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									type="date"
									label="Start Date (MM/DD/YYYY)"
									fullWidth
									name="addStartDate"
									variant='standard'
									value={addStartDate || ""}
									onChange={handleAddDialog}
								>
								</TextField>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									type="text"
									label="Start Time"
									variant='standard'
									fullWidth
									name="addStartTime"
									value={addStartTime || ""}
									onChange={handleAddDialog}
								>
								</TextField>
							</div>
							<div style={{ display: 'flex' }}>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									type="date"
									variant='standard'
									label="End Date (MM/DD/YYYY)"
									fullWidth
									name="addEndDate"
									value={addEndDate || ""}
									onChange={handleAddDialog}
								>
								</TextField>
								<TextField
									style={{ marginTop: "10px" }}
									size="small"
									type="text"
									label="End Time"
									fullWidth
									variant='standard'
									name="addEndTime"
									value={addEndTime || ""}
									onChange={handleAddDialog}
								>
								</TextField>
							</div>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								type="text"
								label="Processing Amount"
								fullWidth
								name="addProcessingAmount"
								value={addProcessingAmount || ""}
								onChange={handleAddDialog}
								variant='standard'

							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								type="text"
								label="Gross Amount"
								fullWidth
								name="addGrossAmount"
								value={addGrossAmount || ""}
								onChange={handleAddDialog}
								variant='standard'

							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								type="text"
								label="Net Final Amount"
								fullWidth
								name="addNetFinalAmount"
								value={addNetFinalAmount || ""}
								onChange={handleAddDialog}
								variant='standard'

							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								type="text"
								label="Unpaid Amount"
								fullWidth
								name="addUnpaidAmount"
								value={addUnpaidAmount || ""}
								onChange={handleAddDialog}
								variant='standard'

							>
							</TextField>
						</DialogContent>
						<DialogActions>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={addVoucherSubmit}
							>
								Submit
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>
			{
				descriptionData.status == "success" && (
					<div>
						<Dialog open={popupHandle} onClose={closePopup}>
							<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
							
							>
								<img src={success} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
								>
									{descriptionData.description}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={closePopup}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)
			}
			{
				descriptionData.status == "failed" && (
					<div>
						<Dialog open={popupHandle} onClose={closePopup}>
							<DialogContent className="text-center"
							
						style={{ backgroundColor: "#00b9f51c" }}
						>
								<img src={failed} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
								>
									{descriptionData.description}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={closePopup}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)
			}
			{/* {
				updateOrDeleteVoucherWireRes.network && (
					<div>
						<Dialog open={popupHandle} onClose={closePopup}>
							<DialogContent className="text-center lightThemeBackground">
								<img src={failed} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
								>
									Please Try Again
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={closePopup}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)
			} */}
		</>
	)
}

export default VoucherWireManager;